import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/icon/ic_arrow_right.svg'


const _hoisted_1 = { class: "client-detail-page" }
const _hoisted_2 = { class: "client-detail-page__body" }
const _hoisted_3 = { class: "client-detail-page__left" }
const _hoisted_4 = { class: "client-detail-page__right" }
const _hoisted_5 = { class: "client-detail-page__basic-info" }
const _hoisted_6 = { class: "client-detail-page__basic-info_left" }
const _hoisted_7 = { class: "client-detail-page__form-item" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "client-detail-page__form-item" }
const _hoisted_10 = ["placeholder"]
const _hoisted_11 = { class: "client-detail-page__form-item" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "client-detail-page__basic-info_right" }
const _hoisted_14 = { class: "client-detail-page__form-item" }
const _hoisted_15 = ["placeholder"]
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = { class: "client-detail-page__form-item" }
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "client-detail-page__edit-wrapper" }
const _hoisted_20 = { class: "client-detail-page__edit-left" }
const _hoisted_21 = { class: "client-detail-page__memo-container" }
const _hoisted_22 = { class: "client-detail-page__form-item" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = { class: "client-detail-page__check-options" }
const _hoisted_25 = { class: "client-page__check_container" }
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "client-detail-page__edit-right" }
const _hoisted_28 = { class: "client-detail-page__button-container" }

import { ref } from 'vue';
import { RouterLink } from 'vue-router';
import ProfilePage from '../Menu/ProfilePage.vue';

//인터페이스
interface ClientInfo {
  name: string;
  chartNumber: string;
  address: string;
  addressDetail: string;
  residentNumber1: string;
  residentNumber2: string;
  birthdate: string;
  memo: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientPage',
  setup(__props) {

const clientInfo = ref<ClientInfo>({
  name: '박민송',
  chartNumber: '3241',
  address: '04323',
  addressDetail:'서울특별시 용산구 한강대로 372 아스테리움 C동 2층(후암동)',
  residentNumber1: '970704',
  residentNumber2: '000000',
  birthdate: '97-07-04',
  memo: '-메모내용-',
});

//check Options
const checkOptions = ['정보제공 동의', '알림톡X', '문자거부'];
const checkedOptions = ref([]);

const handleBtnClick = () => {
  console.log(clientInfo.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "client-detail-page__header" }, [
      _createElementVNode("div", null, [
        _createElementVNode("img", { src: _imports_0 }),
        _createTextVNode(" VVIP")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ProfilePage)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                for: "name",
                class: "client-detail-page__form-label"
              }, "이름", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "client-detail-page__input",
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((clientInfo.value.name) = $event)),
                placeholder: clientInfo.value.name
              }, null, 8, _hoisted_8), [
                [_vModelText, clientInfo.value.name]
              ]),
              _createElementVNode("button", { onClick: handleBtnClick }, "C")
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                for: "chart-number",
                class: "client-detail-page__form-label"
              }, "차트번호", -1)),
              _createElementVNode("input", {
                class: "client-detail-page__input",
                type: "text",
                placeholder: clientInfo.value.chartNumber
              }, null, 8, _hoisted_10),
              _cache[6] || (_cache[6] = _createElementVNode("button", null, "변경", -1))
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[7] || (_cache[7] = _createElementVNode("label", {
                for: "address",
                class: "client-detail-page__form-label"
              }, "주소", -1)),
              _createElementVNode("input", {
                class: "client-detail-page__input",
                type: "text",
                placeholder: clientInfo.value.address
              }, null, 8, _hoisted_12),
              _cache[8] || (_cache[8] = _createElementVNode("button", null, "검색", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _cache[9] || (_cache[9] = _createElementVNode("label", {
                for: "resident-number",
                class: "client-detail-page__form-label"
              }, "주민번호", -1)),
              _createElementVNode("input", {
                class: "client-detail-page__input",
                type: "text",
                placeholder: clientInfo.value.residentNumber1
              }, null, 8, _hoisted_15),
              _cache[10] || (_cache[10] = _createTextVNode(" - ")),
              _createElementVNode("input", {
                class: "client-detail-page__input",
                type: "text",
                placeholder: clientInfo.value.residentNumber2
              }, null, 8, _hoisted_16),
              _cache[11] || (_cache[11] = _createElementVNode("button", null, "공단", -1))
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[12] || (_cache[12] = _createElementVNode("label", {
                for: "name",
                class: "client-detail-page__form-label"
              }, "생년월일", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "client-detail-page__input",
                type: "text",
                placeholder: clientInfo.value.birthdate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientInfo.value.birthdate) = $event))
              }, null, 8, _hoisted_18), [
                [_vModelText, clientInfo.value.birthdate]
              ]),
              _cache[13] || (_cache[13] = _createElementVNode("button", null, "양력", -1)),
              _cache[14] || (_cache[14] = _createElementVNode("input", { type: "checkbox" }, null, -1)),
              _cache[15] || (_cache[15] = _createTextVNode(" 리콜일로부터 "))
            ]),
            _cache[16] || (_cache[16] = _createElementVNode("div", { class: "client-detail-page__form-item" }, [
              _createElementVNode("input", {
                class: "client-detail-page__wide-input",
                type: "text"
              }),
              _createElementVNode("button", null, "편집")
            ], -1))
          ])
        ]),
        _cache[25] || (_cache[25] = _createStaticVNode("<div class=\"client-detail-page__address-wrapper\"><input class=\"client-detail-page__wide-input\" type=\"text\" placeholder=\"서울특별시 용산구 한강대로 372 아스테리움 C동 2층(후암동)\"></div><div class=\"client-detail-page__hospital-info\"><div class=\"client-detail-page__hospital-left\"><div class=\"client-detail-page__form-item\"><label for=\"name\" class=\"client-detail-page__form-label\">리콜구분</label><select class=\"client-detail-page__select\"><option value=\"기본리콜\">기본리콜</option><option value=\"기본리콜\">기본리콜</option></select></div><div class=\"client-detail-page__form-item\"><label for=\"name\" class=\"client-detail-page__form-label\">내원경로</label><select class=\"client-detail-page__select\"><option value=\"지인소개\">지인소개</option><option value=\"지인소개\">지인소개</option></select></div></div><div class=\"client-detail-page__hospital-right\"><div class=\"client-detail-page__form-item\"><label for=\"name\" class=\"client-detail-page_form-label\">최종내원일</label><input type=\"text\" placeholder=\"2024-08-31\" class=\"client-detail-page__wide-input\"></div><div class=\"client-detail-page__form-item\"><label for=\"name\" class=\"client-detail-page_form-label\">소개하신분</label><input type=\"text\" class=\"client-detail-page__wide-input\"><button>검색</button></div></div></div><div class=\"client-detail-page__etc-info\"><div class=\"client-detail-page__separate\"><div class=\"client-detail-page__tendency\"><label for=\"name\" class=\"client-detail-page__form-label\">고객 성향</label><select class=\"client-detail-page__select\"><option value=\"1\">고객성향1</option><option value=\"2\">고객성향2</option></select></div><div class=\"client-detail-page__separate-select\"><label for=\"name\" class=\"client-detail-page__form-label\">구분</label><select class=\"client-detail-page__wide-input\"><option value=\"구분1\">전체 치료 원함</option><option value=\"구분2\">부분 치료 원함</option></select></div><div class=\"client-detail-page__separate-select\"><label for=\"name\" class=\"client-detail-page__form-label\">구분2</label><select class=\"client-detail-page__wide-input\"><option value=\"구분2선택\">- 선택 -</option><option value=\"구분2선택\">- 선택 -</option></select></div></div></div>", 3)),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[17] || (_cache[17] = _createElementVNode("label", {
                  for: "memo",
                  class: "client-detail-page_form-label"
                }, "환자 메모", -1)),
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  class: "client-detail-page__wide-input",
                  placeholder: clientInfo.value.memo,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((clientInfo.value.memo) = $event))
                }, null, 8, _hoisted_23), [
                  [_vModelText, clientInfo.value.memo]
                ])
              ])
            ]),
            _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"client-detail-page__doctor-info\"><label>담당의사/직원</label><select class=\"client-detail-page__select\"><option value=\"직원1\">- 의사 1 -</option><option value=\"직원2\">- 의사 2 -</option></select><select class=\"client-detail-page__select\"><option value=\"직원1\">- 의사 1 -</option><option value=\"직원2\">- 의사 2 -</option></select></div>", 1)),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(checkOptions, (option, index) => {
                  return _createElementVNode("label", { key: index }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      value: option,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((checkedOptions).value = $event))
                    }, null, 8, _hoisted_26), [
                      [_vModelCheckbox, checkedOptions.value]
                    ]),
                    _createTextVNode(" " + _toDisplayString(option), 1)
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _cache[20] || (_cache[20] = _createElementVNode("button", { class: "client-detail-page__button" }, [
                _createTextVNode("신환"),
                _createElementVNode("br"),
                _createTextVNode("등록")
              ], -1)),
              _cache[21] || (_cache[21] = _createElementVNode("button", { class: "client-detail-page__button" }, [
                _createTextVNode("환자"),
                _createElementVNode("br"),
                _createTextVNode("저장")
              ], -1)),
              _cache[22] || (_cache[22] = _createElementVNode("button", { class: "client-detail-page__button" }, "접수", -1)),
              _cache[23] || (_cache[23] = _createElementVNode("button", { class: "client-detail-page__button" }, [
                _createTextVNode(" 문서"),
                _createElementVNode("br"),
                _createTextVNode(" 출력 ")
              ], -1)),
              _createVNode(_unref(RouterLink), { to: "/question" }, {
                default: _withCtx(() => _cache[19] || (_cache[19] = [
                  _createElementVNode("button", { class: "client-detail-page__button" }, "문진표", -1)
                ])),
                _: 1
              }),
              _cache[24] || (_cache[24] = _createElementVNode("div", { class: "client-detail-page__small-buttons" }, [
                _createElementVNode("button", { class: "client-detail-page__small-button" }, "삭제"),
                _createElementVNode("button", { class: "client-detail-page__small-button" }, "설정")
              ], -1))
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})